'use strict';

import _ from 'lodash';

const Verifier = require('./../../system/Verifier');

module.exports = Verifier.define({
	type: 'DateRangeVerifier',

	isEmptyInput(input) {
		return isNaN(new Date(input).getTime());
	},

	init_DateRange: function(options) {
		options = _.defaults(options || {}, {
			minDate: new Date(0),
			maxDate: new Date(2038, 0, 1, 0, 0, 0, 0),
			required: true
		});

		this.required = options.required;
		this.minDate = options.minDate;
		this.maxDate = options.maxDate;
	},

	verify: function(input, strict) {
		if (input === null) {
			let lang = require('./DateRangeVerifierLang');

			return Promise.resolve({
				status: Verifier.STATUS.INVALID,
				title: lang.ERROR,
				message: lang.ERROR
			});
		}

		if (input === undefined) {
			return Promise.resolve({
				status: Verifier.STATUS.NEUTRAL
			});
		}

		return this.Verifier_verify(new Date(input), strict);
	},

	verify_error: function(value) {
		return !this.isEmptyInput(value);
	},

	verify_minDate: function(value) {
		return new Date(value) >= this.minDate;
	},

	verify_maxDate: function(value) {
		return new Date(value) <= this.maxDate;
	}
});
